module.exports = __webpack_public_path__ + "static/media/login-background.7e732351.jpg";